const { REACT_APP_FORMSPREE } = process.env || "mleznwaw";

export const FORMSPREE = `${REACT_APP_FORMSPREE}`;
